import React, { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import toast from "react-hot-toast";

import { uploadProposalVideo } from "../api/prospectingReportsApi";

const ACCEPT = ["video/mp4", "video/webm", "video/quicktime"];
const MAX_BYTES = 50 * 1024 * 1024;
const field =
  "w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#55c5d0]/40";

/** URL paste (YouTube/Vimeo/Loom/Wistia/Matterport/Kuula) + upload-your-own video. */
const VideoEmbedField = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (!ACCEPT.includes(file.type)) { toast.error("Please choose an MP4, WEBM or MOV video."); return; }
    if (file.size > MAX_BYTES) { toast.error("That video is over the 50MB limit."); return; }
    setUploading(true);
    try {
      const { data } = await uploadProposalVideo(file);
      onChange(data.url);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mb-3">
      <label className="block text-xs font-semibold text-gray-500 mb-1">Video / embed link</label>
      <input className={field} value={value || ""} onChange={(e) => onChange(e.target.value)}
        placeholder="Paste a YouTube, Vimeo, Loom, Matterport or Kuula link" />
      <button type="button" onClick={() => inputRef.current && inputRef.current.click()} disabled={uploading}
        className="mt-1 inline-flex items-center gap-1 text-sm font-semibold text-[#0f8d9b] disabled:opacity-50">
        {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {uploading ? "Uploading…" : "Upload a video"}
      </button>
      <p className="text-[11px] text-gray-400 mt-0.5">YouTube · Vimeo · Loom · Wistia · Matterport · Kuula, or upload MP4/WEBM/MOV up to 50MB</p>
      <input ref={inputRef} type="file" accept={ACCEPT.join(",")} className="hidden" onChange={onFile} />
    </div>
  );
};

export default VideoEmbedField;
